import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-voice",
  "use": "icon-voice-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-voice\"><path d=\"M512 628.791983c77.3159 0 139.683343-62.834071 139.683343-140.14997l0.467651-280.299941c0-77.550237-62.600757-140.14997-140.14997-140.14997-77.3159 0-140.14997 62.600757-140.14997 140.14997l0 280.299941C371.85003 565.957913 434.6841 628.791983 512 628.791983zM759.598144 488.640989c0 140.14997-118.427226 238.255359-247.598144 238.255359-128.937604 0-247.598144-98.105389-247.598144-238.255359l-79.418794 0c0 159.53753 127.069047 291.278993 280.299941 313.936015l0 153.230893 93.432972 0L558.715975 802.578028c153.230893-22.658046 280.299941-154.398486 280.299941-313.936015L759.598144 488.642013z\" p-id=\"14363\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/voice.svg
// module id = JV+L
// module chunks = 42